module.exports = __webpack_public_path__ + "img/kallang (4).66e72ae1.jpg";